import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { adminService } from '../services/api';
import '../styles/AdminConfiguracion.css';

const AdminConfiguracion = () => {
  const { esAdmin } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [urlTienda, setUrlTienda] = useState('');

  useEffect(() => {
    if (!esAdmin) {
      navigate('/');
      return;
    }

    cargarConfiguracion();
  }, [esAdmin, navigate]);

  const cargarConfiguracion = async () => {
    try {
      setLoading(true);
      const response = await adminService.getConfiguracion('url_tienda_licencias');
      setUrlTienda(response.data.valor || '');
      setError('');
    } catch (err) {
      console.error('Error al cargar configuración:', err);
      setError('Error al cargar la configuración');
    } finally {
      setLoading(false);
    }
  };

  const handleGuardar = async () => {
    try {
      setGuardando(true);
      setMensaje('');
      setError('');

      await adminService.updateConfiguracion({
        clave: 'url_tienda_licencias',
        valor: urlTienda
      });

      setMensaje('Configuración guardada exitosamente');

      // Limpiar mensaje después de 3 segundos
      setTimeout(() => setMensaje(''), 3000);

    } catch (err) {
      console.error('Error al guardar configuración:', err);
      setError(err.response?.data?.error || 'Error al guardar la configuración');
    } finally {
      setGuardando(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-configuracion">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando configuración...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-configuracion">
      <div className="page-header">
        <h1>Configuración del Sistema</h1>
        <p className="subtitle">Gestiona la configuración general de la aplicación</p>
      </div>

      {mensaje && (
        <div className="mensaje-exito">
          ✓ {mensaje}
        </div>
      )}

      {error && (
        <div className="mensaje-error">
          ✗ {error}
        </div>
      )}

      <div className="config-section">
        <div className="config-card">
          <div className="config-header">
            <h2>🛒 Tienda de Licencias</h2>
            <p>URL de la tienda WooCommerce para compra de licencias</p>
          </div>

          <div className="config-body">
            <div className="form-group">
              <label htmlFor="url-tienda">URL de la Tienda</label>
              <input
                id="url-tienda"
                type="url"
                value={urlTienda}
                onChange={(e) => setUrlTienda(e.target.value)}
                placeholder="https://tutienda.com/licencias"
                className="config-input"
              />
              <small className="help-text">
                Esta URL se mostrará a los usuarios (contratistas y capataces) cuando hagan clic en "Tienda de Licencias"
              </small>
            </div>

            <div className="info-box">
              <strong>ℹ️ Información:</strong>
              <p>
                Los usuarios sin licencia tendrán las siguientes restricciones:
              </p>
              <ul>
                <li><strong>Contratistas:</strong> 20 clientes, 20 productos, 20 servicios, 20 especialidades, 20 trabajadores, 5 capataces</li>
                <li><strong>Capataces:</strong> Solo pueden asociarse a 1 contratista</li>
              </ul>
              <p>
                Al activar una licencia, todas estas restricciones se eliminan.
              </p>
            </div>

            <div className="config-actions">
              <button
                className="btn-guardar"
                onClick={handleGuardar}
                disabled={guardando}
              >
                {guardando ? 'Guardando...' : 'Guardar Configuración'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminConfiguracion;
